import React, { useEffect, useState } from 'react'
import "./Products.css"
import { useSelector, useDispatch } from 'react-redux'
import { clearErrors, getProduct } from "../../actions/productAction"
import Loader from '../layout/Loader/Loader';
import ProductCard from '../Home/ProductCard'
import { useParams } from 'react-router-dom';
import Pagination from 'react-js-pagination'
import Slider from '@material-ui/core/slider'
import Typography from "@material-ui/core/Typography";
import { useAlert } from "react-alert"
import Metadata from "../layout/Metadata"
import { Link } from 'react-router-dom';

const categories = [
    "Laptop",
    "Footwear",
    "Mobile",
    "Men's Wear",
    "Women's Wear",
    "Camera",
]
function Products() {
    const { keyword } = useParams()
    const dispatch = useDispatch()
    const alert = useAlert();
    const [currentPage, setCurrentPage] = useState(1)
    const [ratings, setRatings] = useState(0)
    const { loading,
        error,
        products,
        productsCount,
        resultPerPage,
        filteredProductCount } = useSelector(state => state.products)
    const [price, setPrice] = useState([0, 50000])
    const [category, setCategory] = useState("")
    const setCurrentPageNo = (e) => {
        setCurrentPage(e)
    }

    const priceHandler = (event, newPrice) => {
        setPrice(newPrice)

    }
    useEffect(() => {
        if (error) {
            alert.error(error)
            dispatch(clearErrors())
        }
        dispatch(getProduct(keyword, currentPage, price, category, ratings))
    }, [dispatch, keyword, currentPage, price, category, ratings, alert, error]);

    let count = filteredProductCount
    return <>
        {loading ? <Loader /> :
            <>
                <Metadata title="PRODUCTS -- ECOMMERCE" />
                <h2 className='productHeading'>Products</h2>
                <div className='products'>
                    {products && products.map((product) => (

                        <ProductCard key={product._id} product={product} to={`product/${product._id}`} />

                    ))}
                </div>
                <div className='filterBox'>
                    <Typography>Price</Typography>
                    <Slider
                        value={price}
                        onChange={priceHandler}
                        valueLabelDisplay="auto"
                        aria-labelledby="range-slider"
                        min={0}
                        max={50000} />

                    <Typography>Categories</Typography>
                    <ul className='categoryBox'>
                        {categories.map((category) => (
                            <li
                                className='category-link'
                                key={category}
                                onClick={() => setCategory(category)}
                            >{category}</li>
                        ))}
                    </ul>

                    <fieldset>
                        <Typography component="legend">Ratings Above</Typography>
                        <Slider value={ratings}
                            onChange={(e, newRating) => {
                                setRatings(newRating)
                            }}
                            aria-labelledby="continous-slider"
                            valueLabelDisplay="auto"
                            min={0}
                            max={5} />
                    </fieldset>
                </div>

                {resultPerPage < count && (
                    <div className='paginationBox'>
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={resultPerPage}
                            totalItemsCount={productsCount}
                            onChange={setCurrentPageNo}
                            nextPageText="Next"
                            prevPageText="Prev"
                            firstPageText="1st"
                            lastPageText="Last"
                            itemClass="page-item"
                            linkClass="page-link"
                            activeClass="pageItemActive"
                            activeLinkClass="pageLinkActive"
                        />
                    </div>
                )}
            </>}
    </>
}

export default Products